export const getSanityAuthToken = (): string | null => {
  const raw = localStorage.getItem("__studio_auth_token_rd0y3pad");
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw);
    return parsed.token ?? parsed;
  } catch {
    return raw;
  }
};
